import React from 'react'
import { string, bool } from 'prop-types'

import NotInstallableButton from './NotInstallableButton'

const OwnAppInfo = ({ isService, id, ...props }) => {
  return (
    <NotInstallableButton label="Add to cart" {...props}>
      <>
        You cannot buy your own {isService ? 'service' : 'app'}. If you want to
        install it, go to{' '}
        <a
          href={`${process.env.GATSBY_CONSOLE_URL}/apps/${id}/installation`}
          target="_blank"
          rel="noopener noreferrer"
          className="link"
        >
          Developer Console.
        </a>
      </>
    </NotInstallableButton>
  )
}

OwnAppInfo.propTypes = {
  isService: bool,
  id: string,
}

export default OwnAppInfo
